import { getQwantum as apiGetQwantum } from './api-client';

/**
 * Fetches a single qwantum value by document _id and qwantum key
 * 
 * @param {string|ObjectId} _id - The unique _id of the document
 * @param {string} qwantumId - The key of the qwantum value to retrieve
 * @returns {Promise<any|null>} - The qwantum value if found, null otherwise
 */
export async function getQwantum(_id, qwantumId) {
    try {
        console.log("getQwantum called with:", { _id, qwantumId });
        
        const qwantumValue = await apiGetQwantum(_id, qwantumId);
        console.log("Returning qwantum value:", qwantumValue);
        
        return qwantumValue;
    } catch (error) {
        console.error("Error fetching qwantum:", error);
        throw error;
    }
}